var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',{staticStyle:{"background":"white !important","min-height":"100vh"}},[_c('el-main',{staticClass:"index-main"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }